import { cssVar } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';

interface ImageCardContainerProps {
  $clickable?: boolean;
}

const hoverStyles = css`
  &:hover {
    box-shadow: ${cssVar('shadow-xl')};

    .arrow-icon > path {
      stroke: ${cssVar('gray-light-500')};
    }
  }
`;

export const ImageCardContainer = styled.div<ImageCardContainerProps>`
  .image-card {
    transition: box-shadow 0.3s ease-in-out;

    .arrow-icon {
      min-width: 24px;

      > path {
        transition: all 0.3s ease-in-out;
      }
    }

    ${({ $clickable }) => $clickable && hoverStyles}
  }
`;

interface ImageContainerProps {
  $imageHeight?: number;
  $imageCover?: boolean;
}

export const ImageContainer = styled.div<ImageContainerProps>`
  ${({ $imageHeight }) =>
    $imageHeight &&
    css`
      min-height: ${$imageHeight}px;
      max-height: ${$imageHeight}px;
    `}
  display: ${({ $imageCover }) => ($imageCover ? 'grid' : 'flex')};
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: ${cssVar('radius-xl')};
`;
